import { VUE_ADMIN_URL } from '../config';
import router from '../router/index';

const PUBLIC_PATHS = [
  '/new-admin/sign_in',
  '/new-admin/forgot_password',
  '/ned-admin/reset_password',
  '/new-admin/health-check'
]

const ErrorCatch = (error) => {
  if (error.response) {
    if (error.response.status === 401 && !PUBLIC_PATHS.includes(window.location.pathname)) {
      window.location.href = VUE_ADMIN_URL + '/new-admin/sign_in';
    }
    if (error.response.status === 403) {
      // router.push({ name: 'error' });
      // window.location.reload();
    }
    if (error.response.status === 404) {
      router.push({ name: 'notfound' });
      // window.location.reload();
    }
  }
};

export default ErrorCatch;
